import { __awaiter, __generator, __read } from "tslib";
import { Avatar, Body1, Caption1, Card, CardFooter, CardHeader, CardPreview, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, mergeClasses, SplitButton, } from '@fluentui/react-components';
import { ArrowReply20Regular, CheckmarkCircle20Regular, Comment24Regular, TaskListSquareAdd20Regular, TaskListSquareLtr20Regular, } from '@fluentui/react-icons';
import { ActionMenuIcon } from '@office-start/action-context-menu-control';
import { createActivityItem } from '@office-start/activity-control';
import { ActionsMenuButton, RightClickActionsMenu, useActionsMenuRenderer, } from '@office-start/document-control';
import { ActionContextMenuItemIcon, ActivityNumLines, } from '@office-start/document-types';
import { getKey, KeyboardKey } from '@office-start/keystroke-handler-utility';
import { useTransformDateTimeString } from '@office-start/loc-service';
import { ActionType } from '@office-start/recommended-types';
import { useIsDarkMode } from '@office-start/theming-service';
import React, { forwardRef, useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { useCardStyles } from './RecommendedCardControl.styles';
export var RecommendedSuggestedTaskCardControl = forwardRef(function (_a, ref) {
    var _b, _c;
    var documentActions = _a.documentActions, item = _a.item, moreActionsButtonAriaLabel = _a.moreActionsButtonAriaLabel, isPrimaryActionAdd = _a.isPrimaryActionAdd, onDocClick = _a.onDocClick, onAddToToDoClick = _a.onAddToToDoClick, onMarkAsDoneClick = _a.onMarkAsDoneClick, onViewToDoClick = _a.onViewToDoClick, getPersonPicture = _a.getPersonPicture, PeopleCard = _a.PeopleCard, recommendedSectionResources = _a.recommendedSectionResources, dateResources = _a.dateResources, preferredCulture = _a.preferredCulture;
    var cardClasses = useCardStyles();
    var isDarkMode = useIsDarkMode();
    var _d = __read(useState(''), 2), personPictureUrl = _d[0], setPersonPictureUrl = _d[1];
    var componentRef = useRef(null);
    useEffect(function () {
        var isMounted = true;
        var getUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!getPersonPicture) return [3 /*break*/, 2];
                        return [4 /*yield*/, getPersonPicture(item)];
                    case 1:
                        url = _a.sent();
                        if (isMounted && url) {
                            setPersonPictureUrl("data:image/png;base64,".concat(url));
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        getUrl();
        return function () {
            isMounted = false;
        };
    }, [getPersonPicture, item]);
    var actionMenuItems = (documentActions === null || documentActions === void 0 ? void 0 : documentActions.actionMenuItems) || [];
    var contentActionsEnabled = documentActions === null || documentActions === void 0 ? void 0 : documentActions.contentActionsEnabled;
    var contentActionsGroupInfo = documentActions === null || documentActions === void 0 ? void 0 : documentActions.contentActionsGroupInfo;
    var actionsMenuRenderingPhase = useActionsMenuRenderer(componentRef);
    var cardPreviewIconName = item.isTeamsTask
        ? 'TeamsSvgIcon'
        : 'OutlookSvgIcon';
    var cardPreviewIcon = {
        type: ActionContextMenuItemIcon.Svg,
        iconName: cardPreviewIconName,
    };
    var timestamp = (_b = item.activity) === null || _b === void 0 ? void 0 : _b.timestamp;
    var transformToDateTimeString = useTransformDateTimeString(dateResources, preferredCulture);
    var AvatarElement = useMemo(function () {
        var _a, _b;
        return (React.createElement(Avatar, { image: { src: personPictureUrl }, color: "colorful", name: (_b = (_a = item.activity) === null || _a === void 0 ? void 0 : _a.people[0]) === null || _b === void 0 ? void 0 : _b.name, size: 24 }));
    }, [personPictureUrl, (_c = item.activity) === null || _c === void 0 ? void 0 : _c.people]);
    var people = useMemo(function () {
        var _a;
        if (!!item.activity) {
            return (_a = item.activity) === null || _a === void 0 ? void 0 : _a.people;
        }
        return [];
    }, [item.activity]);
    var activityItem = useMemo(function () {
        var _a;
        return createActivityItem('{0}', ActivityNumLines.Two, transformToDateTimeString(timestamp, false, '', false), people, item.activity ? (_a = item.activity) === null || _a === void 0 ? void 0 : _a.id : ' ', undefined, undefined, true, PeopleCard);
    }, [
        item.activity,
        people,
        timestamp,
        transformToDateTimeString,
        PeopleCard,
    ]);
    var teamsTaskName = item.isTeamsTask && item.title === ''
        ? recommendedSectionResources === null || recommendedSectionResources === void 0 ? void 0 : recommendedSectionResources.defaultTeamsTaskName
        : item.title;
    var onKeyPress = useCallback(function (e) {
        var key = getKey(e);
        if (key !== KeyboardKey.Enter && key !== KeyboardKey.Space) {
            return;
        }
        onDocClick();
    }, [onDocClick]);
    return (React.createElement("div", { ref: componentRef },
        React.createElement(Card, { className: cardClasses.root, id: item.id, tabIndex: 0, ref: ref, focusMode: "no-tab" },
            React.createElement(CardHeader, { className: mergeClasses(cardClasses.header, cardClasses.meetingAndTaskHeader), image: React.createElement("div", { className: cardClasses.activityIcon },
                    React.createElement(Comment24Regular, null)), header: React.createElement(Body1, { block: true, className: mergeClasses(cardClasses.title, cardClasses.text, cardClasses.truncateText) }, recommendedSectionResources === null || recommendedSectionResources === void 0 ? void 0 : recommendedSectionResources.taskTitle), description: React.createElement(Caption1, { className: cardClasses.headerDescription }, activityItem.timeStamp), action: actionMenuItems.length > 0 &&
                    actionsMenuRenderingPhase ? (React.createElement("div", { className: mergeClasses(cardClasses.actionsButtonDisplay, 'show') },
                    React.createElement(ActionsMenuButton, { actions: actionMenuItems, ariaLabel: moreActionsButtonAriaLabel, contentActionsEnabled: contentActionsEnabled, groupInfo: contentActionsGroupInfo, item: item }))) : null }),
            React.createElement(CardPreview, { className: cardClasses.meetingAndTaskPreview },
                React.createElement("div", { className: cardClasses.meetingAndTaskInnerDiv },
                    React.createElement("div", { className: cardClasses.secondHeadingBase },
                        React.createElement("div", { className: cardClasses.iconThumbnail },
                            React.createElement(ActionMenuIcon, { icon: cardPreviewIcon, className: cardClasses.cardPreviewIcon })),
                        React.createElement(Body1, { className: mergeClasses(cardClasses.title, cardClasses.text, cardClasses.truncateText) }, teamsTaskName)),
                    React.createElement("div", { className: mergeClasses(cardClasses.meetingAndTaskInfo, cardClasses.suggestedTaskInfo, isDarkMode
                            ? item.isTeamsTask
                                ? cardClasses.meetingInfoDark
                                : cardClasses.suggestedTaskInfoDark
                            : item.isTeamsTask
                                ? cardClasses.meetingInfoLight
                                : cardClasses.suggestedTaskInfoLight), onClick: onDocClick, onKeyDown: onKeyPress, tabIndex: 0, role: "link" },
                        React.createElement("span", null,
                            item.actionType ===
                                ActionType.Commitment ? (React.createElement(Caption1, { className: cardClasses.insightDescriptionPrefix }, item.insightDescriptionPrefix)) : undefined,
                            PeopleCard ? (React.createElement(PeopleCard, { upn: item.activity.people &&
                                    item.activity.people.length
                                    ? item.activity.people[0]
                                        .upn
                                    : '' }, AvatarElement)) : (AvatarElement),
                            React.createElement(Caption1, { className: mergeClasses(cardClasses.taskActivityDescriptionMargin) }, activityItem.activityDescription),
                            item.actionType ===
                                ActionType.ActionRequest ? (React.createElement(Caption1, { className: cardClasses.insightDescriptionPrefix }, item.insightDescriptionPrefix)) : undefined),
                        React.createElement(Body1, { className: mergeClasses(cardClasses.insightDescription) }, item.insightDescription)))),
            React.createElement(CardFooter, { className: cardClasses.footer },
                React.createElement(Menu, { positioning: "below-end" },
                    React.createElement(MenuTrigger, { disableButtonEnhancement: true }, function (triggerProps) { return (React.createElement(SplitButton, { icon: React.createElement(ArrowReply20Regular, null), onClick: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                        }, menuButton: triggerProps, primaryActionButton: {
                            onClick: function (event) {
                                onDocClick();
                                event.stopPropagation;
                            },
                        } }, recommendedSectionResources === null || recommendedSectionResources === void 0 ? void 0 : recommendedSectionResources.reply)); }),
                    React.createElement(MenuPopover, null,
                        React.createElement(MenuList, null,
                            React.createElement(MenuItem, { key: isPrimaryActionAdd
                                    ? 'addToToDo'
                                    : 'viewInToDo', icon: isPrimaryActionAdd ? (React.createElement(TaskListSquareAdd20Regular, null)) : (React.createElement(TaskListSquareLtr20Regular, null)), onClick: function (e) {
                                    isPrimaryActionAdd
                                        ? onAddToToDoClick()
                                        : onViewToDoClick();
                                    e.stopPropagation();
                                } }, isPrimaryActionAdd
                                ? recommendedSectionResources === null || recommendedSectionResources === void 0 ? void 0 : recommendedSectionResources.addToToDo
                                : recommendedSectionResources === null || recommendedSectionResources === void 0 ? void 0 : recommendedSectionResources.viewInToDo),
                            React.createElement(MenuItem, { key: "done", icon: React.createElement(CheckmarkCircle20Regular, null), onClick: function (e) {
                                    onMarkAsDoneClick();
                                    e.stopPropagation();
                                } }, recommendedSectionResources === null || recommendedSectionResources === void 0 ? void 0 : recommendedSectionResources.done)))))),
        actionMenuItems.length > 0 && actionsMenuRenderingPhase ? (React.createElement(RightClickActionsMenu, { actions: actionMenuItems, componentRef: componentRef, contentActionsEnabled: contentActionsEnabled, groupInfo: contentActionsGroupInfo, item: item })) : null));
});
RecommendedSuggestedTaskCardControl.displayName =
    'RecommendedSuggestedTaskCardControl';
//# sourceMappingURL=RecommendedSuggestedTaskCardControl.js.map